const controllerPath = document.querySelector('predictive-search-dialog')?.dataset.controllerUrl;
const moduleUrl = new URL(controllerPath || './predictive-search-controller.js', import.meta.url);
if (!controllerPath) moduleUrl.search = new URL(import.meta.url).search;

let controllerPromise;
const loadController = () => {
  controllerPromise ||= import(moduleUrl.href);
  return controllerPromise;
};

const openSearch = async (opener) => {
  try {
    await loadController();
    const search = document.querySelector('predictive-search-dialog');
    if (!search || typeof search.open !== 'function') throw new Error('Search controller unavailable.');
    search.open(opener);
  } catch (_) {
    window.location.assign(opener?.href || `${window.Shopify?.routes?.root || '/'}search`);
  }
};

const warmSearch = (event) => {
  if (!event.target.closest?.('[data-search-open]')) return;
  loadController().catch(() => {});
};

document.addEventListener('pointerdown', warmSearch, { capture: true, passive: true });
document.addEventListener('focusin', warmSearch, true);
document.addEventListener('click', (event) => {
  const opener = event.target.closest?.('[data-search-open]');
  if (!opener || customElements.get('predictive-search-dialog')) return;
  event.preventDefault();
  openSearch(opener);
}, true);
